import { Link } from "react-router-dom"
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import '../styles/Login.css'
import { useCallback, useEffect, useRef, useState } from "react"
import { callLoginPost } from "../actions/login"

let Login = ({ methods: { callLoginPost } }) => {
    const refVideo = useRef()
    const [username, setUsername] = useState('')
    const [pass, setPass] = useState('')
    const [visible, setVisible] = useState(false)
    const submit = (e) => {
        e.preventDefault()
        callLoginPost({
            username: username,
            pass: pass
        }, () => {
            window.navigate('/')
        })
    }

    const toggleVisible = () => {
        if (visible) {
            setVisible(false)
        } else {
            setVisible(true)
        }
    }

    const playVideo = useCallback(() => {
        refVideo.current.play()
    }, [refVideo])

    useEffect(() => {
        playVideo()
    }, [playVideo])

    return (
        <div className="container-login d-flex align-items-stretch">
            <div className="sdk d-flex flex-column align-items-center">
                <Link to={'/account/login'} className="logo"><img src="/assets/img/logo.png" alt="Espartaco Soluções" /></Link>
                <div className="authfast-sdk">
                    <div className="box" style={{ width: '100%' }}>
                        <div className="login" style={{ flex: '1 1 0%', maxWidth: '340px' }}>
                            <div className="sign-up">
                                <h1 className="text-center m-0 title-h1">Já sou cadastrado</h1> <span className="separator title-sep"></span>
                                <form onSubmit={submit}>
                                    <div className="form-row">
                                        <div className="col-12 form-group input-group">
                                            <input type="text" placeholder="Digite seu nome de usuário" className="form-control bg-input" style={{ width: 'auto !important' }} onChange={(e) => setUsername(e.target.value)} value={username} />
                                        </div>
                                        <div className="col-md-12 form-group input-group">
                                            <input placeholder="Digite sua senha" type={visible ? 'text' : 'password'} className="form-control bg-input pass" style={{ width: 'auto !important' }} onChange={(e) => setPass(e.target.value)} value={pass} />
                                            <i className="input-group-text hide-pass" onClick={toggleVisible}>
                                                <i className={'fas ' + (visible ? 'fa-eye' : 'fa-eye-slash') + ' fa-2x'}></i>
                                            </i>
                                        </div>
                                        <div className="col-md-12 d-flex align-items-start justify-content-between">
                                            <button type="submit" className="btn-access">Acessar</button>
                                            <Link to={'/'} className="mt-1"><small>Esqueceu a senha?</small></Link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="img d-flex align-items-center shadow-video">
                <video ref={refVideo} loop muted className="bg-video">
                    <source src="/assets/video/background.mp4" type="video/mp4" />
                </video>
            </div>
        </div>
    )
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callLoginPost
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(Login)
